export const RUN_DATE = {
  RUN_DATE: 'Run Date: ',
};
